import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=22db5ed8&scoped=true"
import script from "./FormItem.vue?vue&type=script&lang=js"
export * from "./FormItem.vue?vue&type=script&lang=js"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=22db5ed8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db5ed8",
  null
  
)

export default component.exports